import Icon from "@shared/components/md-design-system/Icon/Icon";
import { colorPalette } from "@shared/config/colorsConfig";
import { supportConfig } from "@shared/config/supportConfig";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { Text, TouchableOpacity, View } from "react-native";

export const CSHotlineCTA = () => {
  const { t } = dynamicTranslations();

  return (
    <View className="flex-row items-center gap-4 bg-gray-100 border border-gray-300 rounded-2xl p-4 gap-2">
      <View className='w-12 h-12 bg-secondary-100 flex items-center justify-center rounded-xl'>
        <Icon name="phone" size={22} color={colorPalette.secondary[600]} />
      </View>
      <View>
        <Text className="text-base">
            {t('screens.deviceTroubleshooting.supportTitle')}
        </Text>
        <TouchableOpacity onPress={supportConfig.call}>
          <Text className="text-primary-700 font-bold text-lg">{supportConfig.phoneNumber}</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}